import { ModalNotificationDetails as NotificationDetails } from '#components'
import axios from 'axios'

export default {
  methods: {
    loadNotifications (type, id) {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/' + type + 's/' + id + '/notifications.json?apikey=' + this.apiKey + this.versionStr)
        } catch(e) {
          this.showError(e)
          reject(e)
          return
        }
        this.notifications = response.data
        resolve(response.data)
      })
    },
    editNotification(notification, allowEmbedded) {
      this.showModal('notificationdetails', NotificationDetails, {
        props: {
          selectedNotification: notification,
          allowEmbedded,
          settings: this.settings
        },
        events: {
          save: this.saveNotification,
          remove: this.deleteNotification
        },
        handlers: {},
        width: 800
      })
    },
    addNotification(allowEmbedded) {
      return this.editNotification({}, allowEmbedded)
    },
    deleteNotification(notification) {
      if (!this.notifications || !this.notifications.length) {
        return
      }
      this.notifications = this.notifications.filter(n => n.id !== notification.id)
    },
    saveNotification(notification) {
      for (let i = 0; i < this.notifications.length; i++) {
        if (this.notifications[i].id === notification.id) {
          this.notifications[i] = notification
          return
        }
      }
      this.notifications.push(notification)
    },
    makeNotificationDesc (notification) {
      if (!notification) {
        return ''
      }
      return notification.name
    },
    makeNotificationType (notification) {
      switch (parseInt(notification.type, 10)) {
        case 1:
          return this._('SMS')
        case 2:
          return this._('Email')
        case 3:
          return this._('Embedded')
        case 4:
          return this._('Zapier')
      }
      return ''
    }
  }
}